import { useEffect, useState } from "react";
import CardProduto, { Produto } from "../../components/CardProduto/CardProduto";
import { useTranslation } from "react-i18next";
import style from "./perfilcleinte.module.css";
import UsuarioItem, { Usuariocard } from "../../components/CardUsuario/CardUsuario";
import api from "../../utils/axios/api";

function PerfilCliente() {
    const { t } = useTranslation("", { keyPrefix: "profile" });
    const [userInfo, setUserInfo] = useState<Usuariocard | null>(null);
    const [productsAlreadyBuyed, setProductsAlreadyBuyed] = useState<Produto[]>([]);
    const [productsFavorites, setProductsFavorites] = useState<Produto[]>([]);
    const clientId = localStorage.getItem("clientId");

    const fetchOrders = async () => {
        try {
            const [response, responseFavorite] = await Promise.all([
                api.get(`/order/client/${clientId}`),
                api.get(`/favorite/client/${clientId}`)
            ]);
            const pedidos = response.data;
            const fav = responseFavorite.data;

            const favorite = fav.map(item => ({
                id: item.product.id,
                name: item.product.name,
                image: [item.product.image],
                description: item.product.description,
                createdAt: item.product.createdAt,
                category: item.product.category,
                quantity: item.product.quantity,
                originalPrice: item.product.originalPrice,
                promotionalPrice: item.product.promotionalPrice,
                brand: item.product.brand,
                space: item.product.space,
                solutions: item.product.solutions,
                problems: item.product.problems,
                storeId: item.product.storeId,
                updatedAt: item.product.updatedAt,
                rating: item.product.rating,
            }))

            const produtosDoBackend: Produto[] = Object.values(
                pedidos
                    .flatMap((pedido: any) =>
                        pedido.product_order.map((item: any) => ({
                            id: item.product.id,
                            name: item.product.name,
                            image: [item.product.image],
                            description: item.product.description,
                            createdAt: item.product.createdAt,
                            category: item.product.category,
                            quantity: item.product.quantity,
                            originalPrice: item.product.originalPrice,
                            promotionalPrice: item.product.promotionalPrice,
                            brand: item.product.brand,
                            space: item.product.space,
                            solutions: item.product.solutions,
                            problems: item.product.problems,
                            storeId: item.product.storeId,
                            updatedAt: item.product.updatedAt,
                            rating: item.product.rating,
                        }))
                    )
                    .reduce((acc: Record<number, Produto>, produto: Produto) => {
                        if (!acc[produto.id]) {
                            acc[produto.id] = produto;
                        }
                        return acc;
                    }, {})
            );

            setProductsAlreadyBuyed(produtosDoBackend);
            setProductsFavorites(favorite)
        } catch (error) {
            console.error("Erro ao buscar pedidos:", error);
        }
    };

    // Função para buscar as informações do usuário
    const fetchUserInfo = async () => {
        const userId = localStorage.getItem("userId");
        const savedImage = localStorage.getItem(`profileImage_${userId}`);
        try {
            const response = await api.get(`/user/${userId}`);
            const userData = response.data;

            const usuario: Usuariocard = {
                id: userData.id,
                name: userData.name,
                email: userData.email,
                cpf: userData.document,
                telefone: userData.telephone,
                imagem: savedImage ?? userData.image ?? null,
            };

            setUserInfo(usuario); // Define as informações do usuário no estado
        } catch (error) {
            console.error("Erro ao buscar informações do usuário:", error);
        }
    };

    useEffect(() => {
        fetchUserInfo();
        fetchOrders();
    }, []);

    return (
        <div>
            <div className={style.tituloContainer}>
                <p className={style.titulo}>{t("profile")}</p>
            </div>

            <div className={style.descricao}>
                {userInfo && <UsuarioItem key={userInfo.id} usuario={userInfo} showButton={true} />}
            </div>

            <div className={style.produtosRelacionadoContainer}>
                <div className={style.row}>
                    <h1 className={style.produtosRelacionadosHeader}>
                        {t("buy_again")}
                    </h1>
                </div>
                <div className={style.listaDeProdutos}>
                    {productsAlreadyBuyed.map((produto) => (
                        <CardProduto key={produto.id} produto={produto} />
                    ))}
                </div>
            </div>

            <div className={style.produtosRelacionadoContainer}>
                <div className={style.row}>
                    <h1 className={style.produtosRelacionadosHeader}>
                        {t("favorites")}
                    </h1>
                </div>
                <div className={style.listaDeProdutos}>
                    {productsFavorites.map((produto) => (
                        <CardProduto key={produto.id} produto={produto} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PerfilCliente;
